<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="80px">
				<el-row>
					<el-col :span="6">
						<el-form-item label="姓名">
							<el-input v-model="searchParams.name"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="状态">
							<select-option-dictionary v-model="searchParams.type" dkey="fp-type"></select-option-dictionary>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="开票时间">
							<el-date-picker value-format="yyyy-MM-dd" v-model="searchParams.kpdate" type="date"
								placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-collapse-transition>
						<div v-if="isShowMoreSearch">
							<!--隐藏区域-->
						</div>
					</el-collapse-transition>
					<div class="search-btn">
						<el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
						<el-button @click="clearSearchVal">清空</el-button>
						<!-- <el-button type="text" v-if="!isShowMoreSearch" @click="isShowMoreSearch = !isShowMoreSearch">
							更多
							<i class="el-icon-arrow-down"></i>
						</el-button>
						<el-button type="text" v-else @click="isShowMoreSearch = !isShowMoreSearch">
							收起
							<i class="el-icon-arrow-up"></i>
						</el-button> -->
					</div>
				</el-row>
			</el-form>
		</div>
		<div class="operator">
			<el-button type="primary" size="mini" v-has-permission-code-and="'00300100'" icon="el-icon-plus"
				@click="toSave()">添加</el-button>
			<el-button type="danger" size="mini" v-has-permission-code-and="'00300110'" icon="el-icon-delete"
				@click="batchRemove()">批量删除</el-button>
		</div>
		<div class="dataTable autoFlex" v-if="listData">
			<el-table class="table" :data="listData.records" stripe border height="auto" @selection-change="selectionChange"
				v-loading="listLoading">
				<el-table-column type="selection" width="55" fixed="left"></el-table-column>
				<!-- <el-table-column prop="sname" label="发销售方名称与纳税号"></el-table-column> -->
				<el-table-column prop="sqdate" label="申请时间" width="106px"></el-table-column>

				<!-- <el-table-column prop="sellname" label="客户姓名"></el-table-column> -->
				<el-table-column prop="name" label="客户姓名" width="99px"></el-table-column>
				<el-table-column prop="phone" label="联系电话" width="110px"></el-table-column>

				<!-- <el-table-column prop="sellnum" label="购方税号"></el-table-column> -->
				<el-table-column prop="cost" label="合计金额" width="97px"></el-table-column>
				<el-table-column prop="bdYear,school,subject,level" label="班级" width="303px">
					<template slot-scope="scope" v-if="scope.row.bdYear">
						{{ scope.row.bdYear }}届{{ scope.row.level }}-{{ scope.row.school }}-{{ scope.row.subject }}
					</template>
				</el-table-column>
				<el-table-column prop="sname" label="项目名字" width="145px"></el-table-column>
				<!-- <el-table-column prop="fppic" label="上传图片"></el-table-column> -->
				<!-- <el-table-column prop="fpemail" label="邮箱地址"></el-table-column> -->
				<el-table-column prop="kpdate" label="开票/审批" width="115px">
					<template slot-scope="scope" v-if="scope.row.bdYear">
						{{ scope.row.kpdate }}/{{ scope.row.spdate }} 
					</template>
				</el-table-column>
				<el-table-column prop="type" label="状态"></el-table-column>
				<!-- <el-table-column prop="crtm" label="创建时间"></el-table-column>
						<el-table-column prop="mdtm" label="修改时间"></el-table-column>
						<el-table-column prop="crer" label="创建人"></el-table-column>
						<el-table-column prop="mder" label="修改人"></el-table-column> -->
				<el-table-column label="操作" fixed="right" width="200px">
					<template slot-scope="scope">
						<!-- 1.未审批 2.待开具 3.已发送 4.审批未通过 5.待发送  -->
						<div class="dataTable-operator" key="">
							<el-button size="mini" @click="toDetail(scope.$index, scope.row)">详情</el-button>
							<el-button size="mini" v-has-permission-code-and="'00300105'"
								v-if="scope.row.type == '未审批' || scope.row.type == '审批未通过'"
								@click="toUpdate(scope.$index, scope.row)">操作</el-button>
							<el-button size="mini" v-has-permission-code-and="'00300115'" v-if="scope.row.type == '待开具'"
								@click="toUpload(scope.$index, scope.row)">上传</el-button>
							<el-button size="mini" v-if="scope.row.type == '待发送' || scope.row.type == '已发送'"
								@click="sendFapiaoEmial(scope.$index, scope.row)">发送</el-button>
							<!-- <el-button size="mini" icon="el-icon-delete" type="danger" @click="remove(scope.$index, scope.row)">删除</el-button> -->
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pageBar">
				<el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
					:page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
					:page-sizes="this.$constant.page.pageSizes"></el-pagination>
			</div>
		</div>
		<edit ref="edit"></edit>
		<add ref="add"></add>
		<upload ref="upload"></upload>
		<detail ref="detail"></detail>
	</div>
</template>
<script>
import edit from './edit.vue';
import add from './add.vue';
import upload from './upload.vue';
import detail from './detail.vue';
import api from '@/api/xueli/fapiao.js';
import selectUserTableDialog from '@/components/biz/selectUserTableDialog/selectUserTableDialog.vue';
import araeCascader from '@/components/biz/araeCascader/araeCascader.vue';
import selectRoleTreeDialog from '@/components/biz/selectRoleTreeDialog/selectRoleTreeDialog.vue';
import selectDepartmentTreeDialog from '@/components/biz/selectDepartmentTreeDialog/selectDepartmentTreeDialog.vue';
import roleTree from '@/components/biz/roleTree/roleTree.vue';
import departmentTree from '@/components/biz/departmentTree/departmentTree.vue';
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue';
import constant from '@/util/constant.js';
 
export default {
	name: 'fapiao',
	components: {
		edit,
		add,
		upload,
		detail,
		selectUserTableDialog,
		araeCascader,
		selectRoleTreeDialog,
		selectDepartmentTreeDialog,
		roleTree,
		departmentTree,
		selectOptionDictionary
	},
	data() {
		return {
			searchParams: {},
			isShowMoreSearch: false,
			listLoading: false,
			listData: [],
			selected: [],
			page: new this.$constant.pageObj(),
			baseURI:constant.serverUrl,
		};
	},
	methods: {
		//获取数据
		list() {
			this.listLoading = true;
			let params = this.$utils.merger(this.searchParams, this.page);
			api.list(params, response => {
				this.listData = response.data;
				this.listLoading = false;
			})

		},
		//发送邮件
		sendFapiaoEmial(index, row) {
			let parameter = {
				id: row.id
			}
			this.$utils.confirm.warning('提示', '确定发送吗？', () => {
				api.sendEmail(
					parameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//去添加
		toSave() {
			this.$refs.add.open(null, '添加发票信息');

		},
		//去上传
		toUpload(index, row) {
			let uploadParameter = {
				id: row.id
			};
			this.$refs.upload.open(uploadParameter, '上传发票');

		},
		//去编辑
		toUpdate(index, row) {
			let editParameter = {
				id: row.id
			};
			this.$refs.edit.open(editParameter, '发票信息');
		},
		//去详情
		toDetail(index, row) {
			let detailParameter = {
				id: row.id
			};
			this.$refs.detail.open(detailParameter, '详情', true);
		},
		//删除
		remove(index, row) {
			let parameter = {
				ids: row.id
			}
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove(
					parameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//批量删除
		batchRemove() {
			if (!this.selected || this.selected.length == 0) {
				this.$utils.msg.info('请选择至少一行');
				return;
			}
			let parameter = {
				ids: this.selected
			};
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove({
					ids: this.selected
				},
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//改变选择项
		selectionChange(val) {
			//清空
			this.selected = [];
			for (let item of val) {
				this.selected.push(item.id);
			}
		},
		//改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		},

		//搜索
		search() {
			this.list();
		},
		//清空搜索框
		clearSearchVal() {
			this.searchParams = {};
		}
	},
	mounted() {
		this.list();

	}

};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>

